import { render, staticRenderFns } from "./ConfigurationShowContainer.vue?vue&type=template&id=51c64e99&scoped=true&"
import script from "./ConfigurationShowContainer.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationShowContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c64e99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
